<!--<search></search>-->
<div>
  <div class="row" style="margin:10px 0px">
    <div class="col-md-12">
      <button class="btn btn-default pull-right" routerLink="/beach/submission/new">Create Submission
      </button>
    </div>
  </div>
  <div class="row" style="margin:10px 0px">
    <div class="col-md-12 table-responsive">
      <table class="table table-striped">
        <thead>
        <tr>
          <th class="col-md-3">Create Date</th>
          <th class="col-md-3">Submitted Date</th>
          <th class="col-md-2">Content</th>
          <th class="col-md-2">Status</th>
          <th class="col-md-2" style="text-align: center">Delete</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="loading">
          <td colspan="100"><i class="fa fa-spinner fa-pulse"></i></td>
        </tr>

        <ng-container *ngIf="!loading">
          <tr *ngFor="let submission of serviceObj.submissions?.results"
              [routerLink]="['/beach/submission', submission.globalid]"
              style="cursor: pointer">
            <td>{{ submission.created_date | date:'short' }}</td>
            <td>{{ submission.date | date:'short' }}</td>
            <td>{{ submission.submission_content | display:serviceObj.submissions.meta.fields.submission_content.choices }}
            </td>
            <td>{{ submission.status }}</td>
            <td style="vertical-align: middle; cursor: pointer; text-align: center;">
              <i *ngIf="serviceObj.submissions.meta.permissions.write && submission.status === 'Not Submitted'" class="fa-regular fa-times-circle fa-lg"
              (click)="delete(submission, $event)"></i>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
      <div class="text-center">
        <ngb-pagination [collectionSize]="serviceObj.submissions?.meta?.count" [(page)]="currentPage"
                        [pageSize]="25" [maxSize]="5" (change)="switchPage()" class="pagination"></ngb-pagination>
      </div>
    </div>
  </div>
</div>

